import { render, staticRenderFns } from "./ListDocTemplate.vue?vue&type=template&id=5f4256d2&scoped=true"
import script from "./ListDocTemplate.vue?vue&type=script&lang=js"
export * from "./ListDocTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4256d2",
  null
  
)

export default component.exports